import { vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl text-primary uppercase" }, "+", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "SearchForm__list" }
const _hoisted_4 = {
  key: 0,
  class: "Button--no-style SearchForm__list-item SearchForm__list-item--disabled"
}
const _hoisted_5 = {
  key: 1,
  class: "Button--no-style SearchForm__list-item SearchForm__list-item--disabled"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "animate-spin mt-2 h-5 w-5 text-primary absolute top-[10px] -translate-y-1/2 -right-7",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import { ref, watch } from 'vue';
import axios from 'axios';


export default {
  __name: 'Search',
  props: {
    selectedMedications: {
        type: Array,
        required: true,
    },
    hasErrors: {
        type: Boolean,
        required: true,
    },
},
  emits: ['addItem'],
  setup(__props, { emit }) {

const props = __props;



const isOpen = ref(false);
const search = ref('');
const isLoading = ref(false);
const searchResults = ref([]);

let controller = null;

const toggleIsOpen = (status) => {
    isOpen.value = status;
};

let timeout = null;
watch(search, (value) => {
    if (value.length > 1) {
        controller = new AbortController();
        clearTimeout(timeout);
        isLoading.value = true;
        timeout = setTimeout(() => {
            axios
                .get(`${jsData.siteUrl}/wp-json/doctor/v1/medications-list?search=${value}`, {
                    signal: controller.signal,
                })
                .then((response) => {
                    searchResults.value = response.data;
                    isOpen.value = true;
                    isLoading.value = false;
                });
        }, 500);
    }
});



const addItemToList = (item) => {
    if (!item.title || !item.title.length) return;

    emit('addItem', {
        ...item,
        variants: item.variants || null,
        selectedVariant: item.variants && item.variants !== 'custom' ? '1x1' : null,
    });

    if (controller) {
        controller.abort();
    }

    isLoading.value = false;
    search.value = '';
    searchResults.value = [];
    isOpen.value = false;
};

return (_ctx, _cache) => {
  return (__props.selectedMedications.length < 1)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        tabindex: "-1",
        onFocusin: _cache[4] || (_cache[4] = $event => (toggleIsOpen(true))),
        onFocusout: _cache[5] || (_cache[5] = $event => (toggleIsOpen(false))),
        class: "SearchForm max-w-[493px] relative"
      }, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["SearchForm__searchInput", { 'SearchForm__searchInput--hasErrors': __props.hasErrors }]),
          type: "text",
          placeholder: "Wpisz nazwę leku",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((search).value = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys($event => (addItemToList({ title: search.value, variants: 'custom' })), ["enter"]))
        }, null, 34), [
          [_vModelText, search.value]
        ]),
        _createElementVNode("button", {
          class: "Button--no-style SearchForm__submitButton flex items-center justify-center",
          type: "button",
          onClick: _cache[2] || (_cache[2] = $event => (addItemToList({ title: search.value, variants: 'custom' }))),
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
        }, _hoisted_2, 32),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          (!searchResults.value.length && search.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Brak rezultatów? Możesz dodać lek ręcznie. "))
            : _createCommentVNode("", true),
          (searchResults.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Często wybierane "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "Button--no-style SearchForm__list-item",
              onClick: $event => (addItemToList(item)),
              key: item.id
            }, _toDisplayString(item.title), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vShow, isOpen.value && !isLoading.value]
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
          : _createCommentVNode("", true)
      ], 32))
    : _createCommentVNode("", true)
}
}

}